import styled, { css } from 'styled-components';
import { mq } from '~/styles/grid';
import CTA from '../../atoms/CTA';
import { getThemeValueByName } from '~/helpers/getColors';

export const GradientOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  mix-blend-mode: ${(props) =>
    props.theme.name === 'fse' ? 'multiply' : 'initial'};
  background: ${({ theme }) =>
    getThemeValueByName(theme, theme.hero.background)};
`;

const StyledLinksWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-auto-flow: column;
  gap: '15px';
  align-items: center;
  width: 100%;
  margin-top: 20px;
  justify-content: ${({ direction }) => direction};

  @media (${mq.xs}) {
    grid-auto-flow: inherit;
    grid-template-columns: 1fr;

    & div,
    & a {
      width: 100%;
      justify-content: center;
    }
  }

  & div {
    margin: 0 auto;
  }

  & a {
    color: white;
  }
  & a:hover {
    color: ${(props) => props.theme.color.cta};
    & span {
      color: ${(props) => props.theme.color.cta} !important;
    }
  }
`;

const StylesContentFMC = styled.span`
  color: white;

  & p {
    font-size: 14px;
  }

  & h2 {
    font-size: 20px;
    font-weight: bold;
  }

  & h3,
  h4,
  h5,
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
`;

const StyledContainerGrid = styled.div`
  z-index: 11;
  display: flex;
  flex-direction: column;
  position: absolute;
  padding: 0 8%;
  width: 70%;
  height: 100%;
  justify-content: center;

  & div,
  a {
    color: white;
  }

  & a:hover span {
    color: white !important;
  }

  & p {
    font-size: ${(props) => props.theme.copytext.copyStandard.fontSize};
  }

  & h2 {
    font-size: ${(props) => props.theme.headline.h600.xl.fontSize};
    font-weight: bold;
    color: white;
  }

  & h3,
  h4,
  h5,
  h6 {
    font-size: ${(props) => props.theme.headline.h500.xl.fontSize};
    font-weight: bold;
    color: white;
    margin-bottom: 10px;
  }

  & h2 + p {
    margin-top: 20px;
  }
  & p + p {
    margin-top: 15px;
  }

  @media (${mq.mdDown}) {
    width: 80%;
    & p {
      font-size: ${(props) => props.theme.copytext.copyStandard.fontSize};
    }

    & h2 {
      font-size: ${(props) => props.theme.headline.h600.xs.fontSize};
      font-weight: bold;
    }

    & h3,
    h4,
    h5,
    h6 {
      font-size: ${(props) => props.theme.headline.h500.xs.fontSize};
      font-weight: bold;
    }
  }

  @media (${mq.smDown}) {
    width: 100%;
  }

  @media (${mq.lgUp}) {
    ${(props) =>
      props.direction === 'RIGHT'
        ? css`
            right: 0;
            align-items: flex-end;
          `
        : css`
            left: 0;
            align-items: flex-start;
          `}
  }
`;

const CTAStyled = styled(CTA)`
  margin-top: ${(props) => props.theme.spacing.xl.spacing500};
  @media (${mq.smDown}) {
    margin-top: ${(props) => props.theme.spacing.xs.spacing500};
  }
`;

export { StyledLinksWrapper, StyledContainerGrid, StylesContentFMC, CTAStyled };
